'use client';
import Perk from '@/components/elements/Properties/Perk';
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { useMediaMatchers } from '@/lib/media_utils';

export default function PropertyPerks({ perks }: { perks: string[] }) {
  const [isExpanded, setIsExpanded] = useState(false);
  const { isMobile } = useMediaMatchers();
  const initialPerks = perks.slice(0, 5);

  return (
    <div className="flex flex-col gap-2">
      <div className="text-xl font-milligram font-bold uppercase">The Perks</div>
      <div className="flex flex-col gap-1 md:flex-row md:flex-wrap">
        {isMobile ? (
          <AnimatePresence>
            {(isExpanded ? perks : initialPerks).map((perk: string) => (
              <motion.div
                key={perk}
                initial={{ opacity: 0, height: 0 }}
                animate={{ opacity: 1, height: 'auto' }}
                exit={{ opacity: 0, height: 0 }}
                transition={{ duration: 0.2 }}
              >
                <Perk type={'default'} perk={perk} hideText={false} />
              </motion.div>
            ))}
          </AnimatePresence>
        ) : (
          perks.map((perk: string) => (
            <Perk key={perk} type={'default'} perk={perk} hideText={false} />
          ))
        )}

        {isMobile && perks.length > 5 && (
          <Button
            variant="link"
            size="sm"
            onClick={() => setIsExpanded(!isExpanded)}
            className="flex items-end gap-1 text-primary hover:text-primary/80"
          >
            {isExpanded ? (
              <>
                Show less
                <ChevronUp className="w-4 h-4" />
              </>
            ) : (
              <>
                Show more
                <ChevronDown className="w-4 h-4" />
              </>
            )}
          </Button>
        )}
      </div>
    </div>
  );
}
